<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
    <v-row no-gutters>
      <v-col>
        <!-- 第一行 -->
        <v-row no-gutters>
          <v-col class="pa-4" cols="12" md="4">
            <v-sheet color="grey darken-3 pa-5">
              <h1 class="title">最新合作项目</h1>
              <p class="subtitle-2 font-weight-light">包括外包技术服务和独立研发项目:</p>
              <div class="adminpro-message-list">
                <ul class="message-list-menu">
                  <li v-for="item in desserts"><span :class="dessertsClass(item.num)">{{item.num}}</span> <span class="message-info">{{item.message}}</span>
                    <span class="message-time">{{item.time}}</span>
                  </li>
                </ul>
              </div>
            </v-sheet>
          </v-col>
          <v-col class="pa-4" cols="12" md="5">
            <v-sheet color="grey darken-3 pa-5">
              <v-row>
                <v-col cols="12" style="height: 204px;">
                  <et-charts :option="flotDashboardChart"></et-charts>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <span class="title d-flex justify-center">￥6321</span>
                  <span class="subtitle-2 d-flex justify-center">业内平均薪资</span>
                </v-col>
                <v-col cols="12" md="6">
                  <span class="title d-flex justify-center">￥13826</span>
                  <span class="subtitle-2 d-flex justify-center">易途外包薪资</span>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col class="pa-4" cols="12" md="3">
            <v-sheet color="grey darken-3 pa-5">
              <h1 class="title">最新技术企业应用比例</h1>
              <p class="subtitle-2 font-weight-light">前端后端技术独立统计:</p>
              <v-row no-gutters>
                <v-col cols="12" md="6">
                  <et-charts :option="sparklinedask1" style="height: 109px;"></et-charts>
                </v-col>
                <v-col cols="12" md="6">
                  <et-charts :option="sparklinedask2" style="height: 109px;"></et-charts>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <p class="subtitle-2 mt-5">此统计数据源于数千易途毕业生现场采用技术 部分技术应用不足1%的未予展现</p>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
    <v-row no-gutters>
      <v-col>
        <!-- 第二行 -->
        <v-row align="start" no-gutters>
          <v-col cols="12" md="4">
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3" v-if="yearMoneyHide">
                  <card-header title="年度完成项目总额" @preMethod="hideContentFn(1)" @preCloseMethod="closeTagsFn(1)"></card-header>
                  <v-container class="pa-5" v-if="yearMoneyContent">
                    <v-row no-gutters class="mb-1">
                      <v-col cols="12" md="8">
                        <h2 class="subtitle-2">2025年度第二季度：</h2>
                      </v-col>
                      <v-col cols="12" md="4" align-self="center">
                        <et-charts :option="minPriceBar" style="height: 16px;"></et-charts>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="8">
                        <a href="#" @click="goToDetail" class="subtitle-2">点击获取详情</a>
                      </v-col>
                      <v-col class="subtitle-2 d-flex flex-row-reverse pr-1" cols="12" md="4">￥19,230,000.00</v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3" v-if="informationHide">
                  <card-header title="Java资讯信息" @preMethod="hideContentFn(2)" @preCloseMethod="closeTagsFn(2)"></card-header>
                  <v-row no-gutters class="pa-5" v-if="informationContent">
                    <v-responsive max-height="428">
                      <vue-scroll>
                        <v-container class="pb-5">
                          <template v-for="(item,index) in latestItems">
                            <v-row no-gutters :key="index">
                              <v-col>
                                <p class="body-2"><a :href="item.url" target="_blank">@{{item.name}} </a>{{item.title}}</p>
                              </v-col>
                            </v-row>
                            <v-row no-gutters class="pb-5 row-line mb-5">
                              <v-col cols="12" md="8" class="caption" align-self="center">
                                <v-icon x-small>mdi-timer</v-icon> {{item.time}}
                              </v-col>
                              <v-col cols="12" md="4" class="d-flex flex-row-reverse" align-self="center">
                                <v-menu offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-btn text icon v-on="on" x-small>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list dense subheader>
                                    <v-list-item v-for="(item, index) in item.keyWords" :key="index">
                                      <v-list-item-content>{{ item }}</v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </template>
                        </v-container>
                      </vue-scroll>
                    </v-responsive>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-4" cols="12" md="5">
            <v-card color="grey darken-3" v-if="mapHide">
              <card-header title="外包服务版图概况" @preMethod="hideContentFn(3)" @preCloseMethod="closeTagsFn(3)"></card-header>
              <v-container class="pa-5" v-if="mapContent">
                <v-responsive max-height="596">
                  <vue-scroll>
                    <v-row no-gutters class="mb-1">
                      <div class="title">易途外包服务覆盖全国24个省份51个城市</div>
                    </v-row>
                    <v-row no-gutters class="mb-1">
                      <div class="body-2"></div>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="12" style="height: 400px;">
                        <et-charts :option="mapData"></et-charts>
                      </v-col>
                    </v-row>
                    <template>
                      <v-row no-gutters v-for="(mapItem,key) in mapDataDesc" :key="key">
                        <v-col cols="12" md="3">
                          <v-card class="pa-2" color="grey darken-3" style="border-color: #303030 !important;" outlined
                            tile>
                            <v-row no-gutters>
                              <v-col cols="12" class="d-flex flex-row-reverse">
                                <v-icon small>mdi-toolbox</v-icon>
                              </v-col>
                              <v-col cols="12" class="d-flex flex-row-reverse">
                                <span class="body-2">{{ mapItem.time }}</span>
                              </v-col>
                              <v-col cols="12" class="d-flex flex-row-reverse">
                                <span class="body-2">{{ mapItem.location }}</span>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="9">
                          <v-card class="pa-2 card-line" color="grey darken-3" style="border-color: #303030 !important;"
                            outlined tile>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <p class="subtitle-2">{{ mapItem.company }}</p>
                              </v-col>
                              <v-col cols="12">
                                <div class="body-2">{{ mapItem.desc }}</div>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </template>
                  </vue-scroll>
                </v-responsive>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3">
                  <card-header title="外包累计吸纳员工" label labelText="!"></card-header>
                  <v-container class="pa-5">
                    <v-row no-gutters class="mb-1">
                      <v-col cols="12" md="10">
                        <span class="headline">1553</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">

                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="10">
                        <span class="body-2">外包吸纳人员:</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">
                        <span class="body-2 teal--text accent-3">16</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3">
                  <card-header title="合作企业总数" label labelText="!" labelColor="cyan accent-3"></card-header>
                  <v-container class="pa-5">
                    <v-row no-gutters class="mb-1">
                      <v-col cols="12" md="10">
                        <span class="headline">391</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">

                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="10">
                        <span class="body-2">本月新增</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">
                        <span class="body-2 teal--text accent-3">5</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3">
                  <card-header title="最近交付项目" label labelText="!" labelColor="teal darken-2"></card-header>
                  <v-container class="pa-5">
                    <v-row no-gutters class="mb-1">
                      <v-col cols="12" md="10">
                        <span class="subtitle-1">山东省档案厅智慧档案管理平台</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">

                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="12">
                        <span class="body-2">交付日期： 2025-09-01</span>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-4">
                <v-card color="grey darken-3">
                  <card-header title="最新签约项目" label labelText="!" labelColor="pink accent-3"></card-header>
                  <v-container class="pa-5">
                    <v-row no-gutters class="mb-1">
                      <v-col cols="12" md="10">
                        <span class="subtitle-1"> 普利思票券核销系统</span>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex flex-row-reverse" align-self="center">

                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="12">
                        <span class="body-2">签约日期：2025-08-03</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col no-gutters class="pa-4">
        <!-- 第三行 -->
        <v-card color="grey darken-3" v-if="listHide">
          <card-header title="技术权重排行" @preMethod="hideContentFn(4)" @preCloseMethod="closeTagsFn(4)"></card-header>
          <v-container class="pa-5" v-if="listContent">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <v-data-table color="grey darken-3" v-model="selected" :headers="headers" :items="tableData"
                  single-select item-key="name" show-select class="elevation-1">
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

    </v-row>
  </v-responsive>
</template>

<script>
  import Mock from 'mockjs';
  import 'echarts/map/js/china'
  export default {
    data() {
      return {
        yearMoneyContent:true,
        yearMoneyHide:true,
        informationContent:true,
        informationHide:true,
        mapContent:true,
        mapHide:true,
        listContent:true,
        listHide:true,
        desserts: [],
        latestItems: [],
        flotDashboardChartData: [],
        selected: [],
        headers: [{
            text: '技术名称',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: '企业应用占比',
            value: 'calories'
          },
          {
            text: '难度系数',
            value: 'fat'
          },
          {
            text: '面试出现概率',
            value: 'carbs'
          },
          {
            text: '对应薪资范围',
            value: 'protein'
          },
        ],
        tableData: [],
        mapDataDesc:
        [
  {
    "time": "2025-02-03",
    "location": "青岛",
    "company": "中译语通科技股份有限公司",
    "desc": "环保设备大数据分析中心项目组   派遣 中级开发人员6人"
  },
  {
    "time": "2025-03-08",
    "location": "济南",
    "company": "山东华软金科信息技术有限公司",
    "desc": "农信社项目组  派遣 中级开发人员2人"
  },
  {
    "time": "2025-03-02",
    "location": "济南",
    "company": "天地伟业技术有限公司",
    "desc": "政法平台项目组   派遣 中级开发人员5人，初级开发人员3人"
  },
  {
    "time": "2025-05-07",
    "location": "青岛",
    "company": "北京华路时代信息技术股份有限公司",
    "desc": "国家电网项目组  派遣 中级开发5人"
  },
  {
    "time": "2025-05-06",
    "location": "青岛",
    "company": "上海数聚软件系统股份有限公司",
    "desc": "浦发银行项目组  派遣  高级开发人员2人，中级开发4人"
  },
  {
    "time": "2025-06-10",
    "location": "天津",
    "company": "天地伟业技术有限公司",
    "desc": "政法平台项目组 派遣 中级开发人员6人，初级开发人员4人"
  },
  {
    "time": "2025-09-09",
    "location": "东营",
    "company": "山东胜软科技股份有限公司",
    "desc": "石化智云油田服务项目组  派遣 中级开发人员3人"
  },
  {
    "time": "2025-09-04",
    "location": "东营",
    "company": "山东胜软科技股份有限公司",
    "desc": "智能油气平台  派遣 高级开发人员1人，中级开发人员4人"
  },
  {
    "time": "2025-05-11",
    "location": "东营",
    "company": "山东胜软科技股份有限公司",
    "desc": "石化研究院项目  派遣 高级开发人员3人，中级开发人员10人"
  },
  {
    "time": "2025-07-01",
    "location": "济南",
    "company": "山东中创软件工程股份有限公司",
    "desc": "银行租赁金融项目  派遣 高级开发人员2人，中级开发人员3人"
  },
  {
    "time": "2025-06-06",
    "location": "济南",
    "company": "山东中创软件工程股份有限公司",
    "desc": "招商局供应链项目  派遣 中级开发人员2人"
  },
  {
    "time": "2025-05-12",
    "location": "济南",
    "company": "山东通维信息工程有限公司",
    "desc": "山东高速智能运维项目 派遣 高级开发人员4人，中级开发人员8人"
  },
  {
    "time": "2025-05-03",
    "location": "济南",
    "company": "山东山大华天软件有限公司",
    "desc": "3DPlaza-云capp项目  派遣 高级开发人员3人，中级开发人员4人"
  },
  {
    "time": "2025-05-08",
    "location": "济南",
    "company": "山东山大华天软件有限公司",
    "desc": "中船重工PLM集成接口开发及实施项目  派遣 高级开发人员2人，中级开发人员6人"
  },
  {
    "time": "2025-07-10",
    "location": "济南",
    "company": "山东山大华天软件有限公司",
    "desc": "上汽试制数字化项目  派遣 高级开发人员1人，中级开发人员3人"
  },
  {
    "time": "2025-09-02",
    "location": "济南",
    "company": "山东鲁能软件有限公司",
    "desc": "作业安全管控项目  派遣 高级开发人员5人，中级开发人员14人"
  },
  {
    "time": "2025-05-01",
    "location": "济南",
    "company": "山东鲁能软件有限公司",
    "desc": "输电管控平台项目  派遣 高级开发人员8人，中级开发人员21人"
  }
],
        
      }
    },
    computed: {
      dessertsClass(num) {
        return function(num) {
          let returnClass = "message-serial "
          switch (num) {
            case 1:
              return returnClass + "message-cl-one"
            case 2:
              return returnClass + "message-cl-two"
            case 3:
              return returnClass + "message-cl-three"
            case 4:
              return returnClass + "message-cl-four"
            case 5:
              return returnClass + "message-cl-five"
          }
          return returnClass
        }
      },
      flotDashboardChart() {

        return {
          color: ["#03a9f4", "#0055ff"],
          tooltip: {
            trigger: 'none',
            axisPointer: {
              type: 'cross'
            },
            show: true
          },
          grid: {
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px"
          },
          xAxis: [{
            show: false,
            data: [5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500,13000]
          }],
          yAxis: [{
            type: 'value',
            show: false
          }],
          series: [{
              type: 'line',
              smooth: true,
              areaStyle: {},
              symbol: 'none',
              data: [6000,5500,6000,6500,6000,5500,7000,7500,6000,6500,6000,6500,6500,6000,5500,6500,7000]
          },
            {
              type: 'line',
              smooth: true,
              areaStyle: {},
              symbol: 'none',
              data: [11500,12000,11000,12500,13000,11500,10500,11000,13000,12000,12000,10500,11000,11500,12000,12500,11500]
            }
          ]
        }
      },
      sparklinedask1() {
        return {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [{
            radius: [0, 40],
            center: ['50%', '50%'],
            name: '后台技术',
            type: 'pie',
            label: {
              show: false
            },
            data: [{
                value: 783,
                name: 'Spring Boot'
              },
              {
                value: 431,
                name: 'Spring Cloud'
              },
              {
                value: 81,
                name: 'SSH'
              },
              {
                value: 127,
                name: 'SSM'
              },
              {
                value: 13,
                name: 'Servlet'
              }
            ]
          }]
        }
      },
      sparklinedask2() {
        return {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [{
            radius: [0, 40],
            center: ['50%', '50%'],
            name: '前端技术',
            type: 'pie',
            label: {
              show: false
            },
            data: [{
                value: 36,
                name: 'Dojo'
              },
              {
                value: 49,
                name: 'Angular'
              },
              {
                value:1132,
                name: 'Vue'
              },
              {
                value: 233,
                name: 'JQuery'
              },
              {
                value: 50,
                name: 'React'
              }
            ]
          }]
        }
      },
      minPriceBar() {
        return {
          xAxis: [{
            show: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          }],
          yAxis: [{
            show: false
          }, ],
          series: [{
              name: '',
              type: 'bar',
              data: [2.0, 4.9, 7.0, 10.2, 5.6, 6.7, 3.6, 6.2, 2.6, 2.0, 6.4, 3.3]
            },
            {
              name: '',
              type: 'bar',
              data: [2.6, 5.9, 9.0, 4, 8.7, 7.7, 5.6, 8.2, 4.7, 1.8, 6.0, 2.3]
            },
          ]
        }
      },
      mapData() {
        return {
          backgroundColor: "#424242",
          tooltip: {}, // 鼠标移到图里面的浮动提示框
          dataRange: {
            show: false,
            min: 0,
            max: 1000,
            text: ['High', 'Low'],
            realtime: true,
            calculable: true,
            color: ['orangered', 'yellow', 'lightskyblue']
          },
          geo: { // 这个是重点配置区
            map: 'china', // 表示中国地图
            roam: false,
            itemStyle: {
              normal: {
                borderColor: '#424242'
              },

            }
          },
          series: [{
              type: 'scatter',
              coordinateSystem: 'geo' // 对应上方配置
            },
            {
              name: '', // 浮动框的标题
              type: 'map',
              geoIndex: 0,
              data: [{
                "name": "山东",
                "value": 181
              }, {
                "name": "江苏",
                "value":63
              }, {
                "name": "上海",
                "value": 58
              }, {
                "name": "天津",
                "value": 53
              }, {
                "name": "北京",
                "value": 49
              }, {
                "name": "浙江",
                "value": 48
              }, {
                "name": "新疆",
                "value": 13
              }, {
                "name": "吉林",
                "value": 15
              }, {
                "name": "广东",
                "value": 25
              }, {
                "name": "辽宁",
                "value": 12
              }, {
                "name": "陕西",
                "value": 13
              }, {
                "name": "内蒙古",
                "value": 8
              }, {
                "name": "宁夏",
                "value": 2
              }, {
                "name": "甘肃",
                "value": 5
              }, {
                "name": "河北",
                "value": 4
              }, {
                "name": "山西",
                "value": 3
              }, {
                "name": "河南",
                "value": 3
              }, {
                "name": "福建",
                "value": 9
              }, {
                "name": "四川",
                "value": 8
              }, {
                "name": "重庆",
                "value": 6
              }, {
                "name": "湖南",
                "value": 2
              }, {
                "name": "贵州",
                "value": 2
              }, {
                "name": "云南",
                "value": 7
              }, {
                "name": "海南",
                "value": 2
              }]
            }
          ]
        }
      }
    },
    methods: {
      hideContentFn(val){
          switch (val) {
              case 1 :
                  this.yearMoneyContent = !this.yearMoneyContent;
                  break;
              case 2 :
                  this.informationContent = !this.informationContent;
                  break;
              case 3 :
                  this.mapContent = !this.mapContent;
                  break;
              case 4 :
                  this.listContent = !this.listContent;
                  break;
          }

      },
      closeTagsFn(val){
          switch (val) {
              case 1 :
                  this.yearMoneyHide = !this.yearMoneyHide;
                  break;
              case 2 :
                  this.informationHide = !this.informationHide;
                  break;
              case 3 :
                  this.mapHide = !this.mapHide;
                  break;
              case 4 :
                  this.listHide = !this.listHide;
                  break;
          }
      },
      initDesserts() {
        /*
        let data = Mock.mock({
          "data|6": [{
            "id": '@guid',
            "num|1-5": 5,
            "message|1-10": "★",
            "time|+1": '@time("HH:mm A")'
          }]
        })
        this.desserts = data.data

        */
        this.desserts = [
          {"id":"1","num":1,"message":"中译语通科技股份有限公司","time":"2025-05-13"},
          {"id":"2","num":2,"message":"山东巨彩二期","time":"2025-05-10"},
          {"id":"3","num":3,"message":"山东华软金科信息技术有限公司","time":"2025-05-08"},
          {"id":"4","num":4,"message":"天地伟业技术有限公司","time":"2025-05-08"},
          {"id":"5","num":5,"message":"北京华路时代信息技术股份有限公司","time":"2025-05-07"},
          {"id":"6","num":6,"message":"国家电网(长春)短信平台","time":"2025-03-22"},

        ]
      },
      initLatestItems() {
        // let data = Mock.mock({
        //   "data|6-10": [{
        //     "name": '@name()',
        //     "content": '@cparagraph(2)',
        //     "time": '@datetime'
        //   }]
        // })
          const data = [
              {
                name: 'JRebel',
                title: 'JRebel ：2025 年 Java 技术报告',
                time: '2025年02月23日',
                url:'http://www.199it.com/archives/1011041.html',
                keyWords:['Java','行业资讯']
              },
              {
                  name: '编程语言',
                  title: '2025年什么编程语言最受欢迎，待遇最高？',
                  time: '2025年09月18日',
                  url:'http://www.199it.com/archives/939371.html',
                  keyWords:['Java','行业资讯','编程语言']
              },
              {
                  name: 'CFF',
                  title: 'CFF：Java 和 JavaScript 是企业开发所用最普遍的语言',
                  time: '2025年08月24日',
                  url:'http://www.199it.com/archives/764795.html',
                  keyWords:['Java','行业资讯','编程语言','生活数据']
              },
              {
                  name: 'JetBrains',
                  title: 'JetBrains：2025年全球开发者调查报告',
                  time: '2025年06月19日',
                  url:'http://www.199it.com/archives/894033.html',
                  keyWords:['Java','行业资讯','编程语言','生活数据']
              },
              {
                  name: 'RedMonk',
                  title: 'RedMonk：2025年全球编程语言榜',
                  time: '2025年03月25日',
                  url:'http://www.199it.com/archives/850697.html',
                  keyWords:['Java','行业资讯','编程语言']
              }
          ];
        this.latestItems = data;
      },
      loadFlotDashboardChartData() {
        let data = Mock.mock({
          "data|6-14": [{
            "data1|50-450": 450,
            "data2|50-450": 450,
          }]
        })

      },
      initTableData() {
        // let data = Mock.mock({
        //   "data|6-14": [{
        //     "name": '@name()',
        //     "calories|100-300": 159,
        //     "fat": '@float(60, 100, 1, 2)',
        //     "carbs|10-30": 24,
        //     "protein": '@float(60, 100, 1, 2)',
        //     iron: '@integer(60, 100)' + '%',
        //   }]
        // })
        const data = [
              {
                name:'spring',
                calories:'98%',
                fat:'0.54',
                carbs:'98%',
                protein:'12-18k'
              },
              {
                name:'springBoot',
                calories:'54.56%',
                fat:'0.32',
                carbs:'82.34%',
                protein:'12-18k'
              },
              {
                name:'springCloud',
                calories:'30.04%',
                fat:'0.52',
                carbs:'83.56%',
                protein:'12-18k'
              },
              {
                name:'springmvc',
                calories:'60%',
                fat:'0.53',
                carbs:'97%',
                protein:'10-14k'
              },
              {
                name:'struts2',
                calories:'8.85%',
                fat:'0.46',
                carbs:'8%',
                protein:'6-8k'
              },
              {
                name:'servlet',
                calories:'0.91%',
                fat:'0.20',
                carbs:'5%',
                protein:'4-6k'
              },
              {
                name:'webservice',
                calories:'66%',
                fat:'0.45',
                carbs:'67%',
                protein:'10-14k'
              },
              {
                name:'quartz',
                calories:'78%',
                fat:'0.43',
                carbs:'69%',
                protein:'12-16k'
              },
              {
                name:'mybatis',
                calories:'82%',
                fat:'0.53',
                carbs:'80%',
                protein:'10-18k'
              },
              {
                name:'ibatis',
                calories:'5%',
                fat:'0.56',
                carbs:'11%',
                protein:'10-13k'
              },
               {
                name:'hibernate',
                calories:'5.64%',
                fat:'0.69',
                carbs:'38%',
                protein:'10-13k'
              },
              {
                name:'jdbc',
                calories:'3.21%',
                fat:'0.21',
                carbs:'6%',
                protein:'5-6k'
              },
              {
                name:'maven',
                calories:'80%',
                fat:'0.46',
                carbs:'32%',
                protein:'10-20k'
              },
              {
                name:'mysql',
                calories:'80%',
                fat:'0.63',
                carbs:'95%',
                protein:'10-16k'
              },
              {
                name:'oracle',
                calories:'45%',
                fat:'0.70',
                carbs:'83%',
                protein:'10-18k'
              },
              {
                name:'dubbo',
                calories:'12%',
                fat:'0.74',
                carbs:'12%',
                protein:'10-18k'
              },
              {
                name:'vue',
                calories:'75.47%',
                fat:'0.68',
                carbs:'75%',
                protein:'10-18k'
              },
              {
                name:'JQuery',
                calories:'15.53%',
                fat:'0.68',
                carbs:'69%',
                protein:'10-14k'
              },
               {
                name:'jsp',
                calories:'2%',
                fat:'0.82',
                carbs:'56%',
                protein:'8-10k'
              },
              {
                name:'react',
                calories:'3.33%',
                fat:'0.76',
                carbs:'2%',
                protein:'8-12k'
              },
              {
                name:'Bootstrap',
                calories:'36%',
                fat:'0.46',
                carbs:'16%',
                protein:'10-14k'
              },
              {
                name:'dojo',
                calories:'2.40%',
                fat:'0.86',
                carbs:'1%',
                protein:'8-12k'
              },
              {
                name:'Angular',
                calories:'3.27%',
                fat:'0.82',
                carbs:'6%',
                protein:'8-12k'
              },
               {
                name:'echarts',
                calories:'78%',
                fat:'0.23',
                carbs:'56%',
                protein:'10-13k'
              },
        ];
        this.tableData = data;
      },
      goToDetail(){
          this.$router.push("/research");
          let x = this.$store.state.tabItem.find((x) => x && x.id == this.$store.state.menuItems[2].items[0].id);
          if(x) return;
          this.$store.commit("addTabItem",this.$store.state.menuItems[2].items[0]);
      }
    },
    created() {
      this.initDesserts()
      this.loadFlotDashboardChartData()
      this.initLatestItems()
      this.initTableData()
    }
  }
</script>
<style scoped="scoped">
  a {
    text-decoration: none;
  }

  .row-line {
    border-bottom: 1px solid #303030;
  }

  .message-list-menu {
    list-style: outside none none;
    margin: 0;
    padding: 0;
  }

  ul.message-list-menu li {
    padding: 5px 0px;
    font-size: 14px;
  }

  ul.message-list-menu li {
    padding: 5px 0px;
    font-size: 14px;
    border-bottom: 1px solid #303030;
  }

  ul.message-list-menu li:last-child {
    padding-bottom: 0px;
    border-bottom: 0px solid #ddd;
  }

  ul.message-list-menu li .message-time {
    text-align: right;
  }

  ul.message-list-menu li .message-info {
    width: 62%;
    ;
    display: inline-block;
  }

  ul.message-list-menu li .message-serial {
    width: 25px;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    background: #303030;
    color: #fff;
    border-radius: 4px;
    padding: 2px 0px;
  }

  ul.message-list-menu li .message-serial.message-cl-one {
    background: #03a9f0;
  }

  ul.message-list-menu li .message-serial.message-cl-two {
    background: #303030;
  }

  ul.message-list-menu li .message-serial.message-cl-three {
    background: #1ab394;
  }

  ul.message-list-menu li .message-serial.message-cl-four {
    background: #ccc;
    color: #303030;
  }

  ul.message-list-menu li .message-serial.message-cl-five {
    background: #1c84c6;
  }
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue